import { createSlice } from "@reduxjs/toolkit";

const defaultFormValueWarranty = {
    status: "",
    rejection_reason: "",
};

const initialState = {
    // warranty state
    showDrawerWarranty: false,
    formTypeWarranty: "",
    initialValuesWarranty: { ...defaultFormValueWarranty },
    paginationWarranty: {
        pageNo: 0,
        limit: 10,
        sortBy: "DESC",
        sortField: "created_at",
        keywords: "",
    },
    // filters
    filtersWarranty: {
        status: null,
        product_id: null,
        start_date: null,
        end_date: null,
    },
    // selected warranty for details
    selectedWarranty: null,
    showWarrantyDetails: false,
};

export const warrantySlice = createSlice({
    name: "warranty",
    initialState,
    reducers: {
        // warranty state
        changeWarrantyInitialState: (state, action) => {
            const { showDrawer, formType, initialValues } = action.payload;

            state.showDrawerWarranty = showDrawer;
            if (formType) state.formTypeWarranty = formType;
            if (initialValues) state.initialValuesWarranty = initialValues;
            if (!initialValues) state.initialValuesWarranty = defaultFormValueWarranty;
        },
        handlePaginationStateWarranty: (state, action) => {
            const { payload } = action;
            state.paginationWarranty = payload;
        },
        // filters
        updateFiltersWarranty: (state, action) => {
            const { payload } = action;
            state.filtersWarranty = { ...state.filtersWarranty, ...payload };
        },
        resetFiltersWarranty: (state) => {
            state.filtersWarranty = {
                status: null,
                product_id: null,
                start_date: null,
                end_date: null,
            };
        },
        // warranty details
        setSelectedWarranty: (state, action) => {
            state.selectedWarranty = action.payload;
        },
        setShowWarrantyDetails: (state, action) => {
            state.showWarrantyDetails = action.payload;
        },
    },
});

// Action creators are generated for each case reducer function
export const {
    changeWarrantyInitialState,
    handlePaginationStateWarranty,
    updateFiltersWarranty,
    resetFiltersWarranty,
    setSelectedWarranty,
    setShowWarrantyDetails,
} = warrantySlice.actions;

export default warrantySlice;
